import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../../../store";
import { GetIssueboardFavoritesApiResponse, openapi } from "../../../../openapi";
import { selectCurrentProjectId } from "../../../global/globalSliceCommon";

const EMPTY_ARRAY: GetIssueboardFavoritesApiResponse = [];
export const selectHttpFavoriteIssueboardIds = createSelector(
  [(state: IRootState) => state, selectCurrentProjectId],
  (state, projectId) => {
    const q = openapi.endpoints.getIssueboardFavorites.select({ projectId })(state);
    return q?.data ?? EMPTY_ARRAY;
  },
);
